export default function ({ app, $config }) {
  if (process.client) {
    const checkUnleashAndInjectOneTrust = () => {
      if (app.$unleash && app.$unleash.isEnabled("showOneTrustBanner")) {
        injectOneTrustScripts();
      }
    };

    const injectOneTrustScripts = () => {
      if (
        document.querySelector("[data-onetrust-loaded]") ||
        document.querySelector("[data-domain-script]") ||
        window.OneTrust ||
        window.OptanonWrapper ||
        window.__ONETRUST_INJECTING__
      ) {
        return;
      }

      window.__ONETRUST_INJECTING__ = true;

      const autoBlockScript = document.createElement("script");
      autoBlockScript.type = "text/javascript";
      autoBlockScript.src = `${$config.ONETRUST_URL}/consent/${$config.ONETRUST_ID}/OtAutoBlock.js`;
      autoBlockScript.setAttribute("data-onetrust-loaded", "true");
      autoBlockScript.onload = () => {
        window.__ONETRUST_INJECTING__ = false;
      };
      autoBlockScript.onerror = () => {
        window.__ONETRUST_INJECTING__ = false;
      };
      document.head.appendChild(autoBlockScript);

      const sdkStubScript = document.createElement("script");
      sdkStubScript.src = `${$config.ONETRUST_URL}/scripttemplates/otSDKStub.js`;
      sdkStubScript.type = "text/javascript";
      sdkStubScript.charset = "UTF-8";
      sdkStubScript.setAttribute("data-domain-script", $config.ONETRUST_ID);
      document.head.appendChild(sdkStubScript);

      const wrapperScript = document.createElement("script");
      wrapperScript.type = "text/javascript";
      wrapperScript.textContent = "function OptanonWrapper() {}";
      document.head.appendChild(wrapperScript);
    };

    if (app.$unleash) {
      checkUnleashAndInjectOneTrust();
    } else {
      const checkInterval = setInterval(() => {
        if (app.$unleash) {
          clearInterval(checkInterval);
          checkUnleashAndInjectOneTrust();
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkInterval);
      }, 10000);
    }
  }
}
